import { useLenis } from 'lenis/react';
import { useState } from 'react';

export type ScrollDirection = 1 | -1 | 0;

const useScrollDirection = () => {
  const [direction, setDirection] = useState<ScrollDirection>(0);

  useLenis(({ direction }) => {
    setDirection(direction);
  });

  return direction;
};

export default useScrollDirection;
